import { createSlice, PayloadAction } from '@reduxjs/toolkit';

interface Company {
  id: string;
  name: string;
  domain: string | null;
  created_at: string;
  updated_at: string;
}

interface CompanyState {
  currentCompany: Company | null;
  loading: boolean;
}

const initialState: CompanyState = {
  currentCompany: null,
  loading: false,
};

const companySlice = createSlice({
  name: 'company',
  initialState,
  reducers: {
    setCurrentCompany: (state, action: PayloadAction<Company | null>) => {
      state.currentCompany = action.payload;
    },
    setLoading: (state, action: PayloadAction<boolean>) => {
      state.loading = action.payload;
    },
  },
});

export const { setCurrentCompany, setLoading } = companySlice.actions;
export default companySlice.reducer;